var noCase = require('no-case');

var upperCaseFirst = require('upper-case-first');
/**
 * Sentence case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */


module.exports = function (value, locale) {
  return upperCaseFirst(noCase(value, locale), locale);
};